import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";
import * as constantsBrand from "../../../../constants/actions/RetreadBrands";
import * as constantsModels from "../../../../constants/actions/RetreadModels";
import * as APIS from "../../../../constants/apis";

function deleteDimension(id, band, dimensions, t) {
  if (window.confirm(t("alerts.r-tire-item-13"))) {
    return dispatch => {
      trackPromise(fetch(`${APIS.API_REST_RETREADDIMENSIONS
        .replace("retreadband_id", band.id)}/${id}`, {
        headers: {
          "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
          "Accept-language": localStorage.getItem("LanguageSelected"),
        },
        method: "DELETE"
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(t("alerts.r-tire-item-4"));
          }
          return response.json();
        })
        .then(json => {
          dispatch(getReqSuccess(band, dimensions, json.message));
          return fetch(APIS.API_REST_RETREADDIMENSIONS
            .replace("retreadband_id", band.id), {
            headers: {
              "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
              "Accept-language": localStorage.getItem("LanguageSelected"),
            }
          });
        })
        .then(response => response.json())
        .then(json => {
          dispatch(getDimensionsSuccess({
            band: band,
            dimensions: json.RetreadDimentions
          }));
        })
        .catch(error => {
          dispatch(getReqError(band, dimensions, error.toString()));
        }));
    };
  } else {
    return dispatch => {
      dispatch(getDimensionsSuccess({
        band: band,
        dimensions: dimensions
      }));
    };
  }
};

export function getDimensionsSuccess(json) {
  return {
    type: constantsModels.GET_MODEL_SUCCESS,
    json
  };
};

export function getReqSuccess(band, dimensions, message) {
  const json = {
    band: band,
    dimensions: dimensions,
    message: message
  };
  return {
    type: constantsBrand.REQUEST_SUCCESS,
    json
  };
};

export function getReqError(band, dimensions, error) {
  const json = {
    band: band,
    dimensions: dimensions,
    error: error
  };
  return {
    type: constantsBrand.REQUEST_ERROR,
    json
  };
};

class RetreadDimensionDeleteItem extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { band, dimensions, dimensionDelete, deleteDimension } = this.props;
    return (
      <React.Fragment>
        <button onClick={() => deleteDimension(dimensionDelete.id, band,
          dimensions, this.props.t)}
          className="btn btn-danger">
          <i className="fa fa-trash"></i> {this.props.t("globals.delete")}
        </button>
      </React.Fragment>
    );
  };
}

const structuredSelector = createStructuredSelector({
  band: state => state.band,
  dimensions: state => state.dimensions
});

const mapDispatchToProps = { deleteDimension };

export default connect(structuredSelector, mapDispatchToProps)(RetreadDimensionDeleteItem);
